var React = require('react');

function Sheet (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"iconmonstr-file-19","transform":"translate(0)"},[React.createElement("path",{"id":"Path_129","data-name":"Path 129","d":"M21.829,13.558S24.371,0,16.236,0H2V40.675H35.9V18.643C35.9,12.881,27.083,12.372,21.829,13.558ZM22.338,32.2H8.779V30.506H22.338Zm6.779-5.084H8.779V25.422H29.117Zm0-5.084H8.779V20.338H29.117Z","transform":"translate(-2)","fill":"#191919","key":0}),React.createElement("path",{"id":"Path_130","data-name":"Path 130","d":"M14.6.1c3.729,1.864,10,8.3,12.542,11.694A14.723,14.723,0,0,0,16.8,9.76C17.142,7.218,16.464,1.964,14.6.1Z","transform":"translate(6.755 0.069)","fill":"#25d2c8","key":1})]));
}

Sheet.defaultProps = {"width":"33.896","height":"40.675","viewBox":"0 0 33.896 40.675"};

module.exports = Sheet;

Sheet.default = Sheet;
